import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useQuestionnaireBuilderStore = create(
  persist(
    (set) => ({
      questionnaireData: {
        title: "",
        scope: "",
        instructions: "",
        questionnaire_type: 0,
        external_id: "",
        questionnaire_json: null,
      },
      questions: [],
      setQuestionnaireData: (data) => set({ questionnaireData: data }),
      setQuestions: (questions) => set({ questions }),
      addQuestion: (question) => set((state) => ({ questions: [...state.questions, question] })),
      removeQuestion: (index) =>
        set((state) => ({
          questions: state.questions.filter((_, i) => i !== index),
        })),
      resetForm: () =>
        set({
          questionnaireData: {
            title: "",
            scope: "",
            instructions: "",
            questionnaire_type: 0,
            external_id: "",
            questionnaire_json: null,
          },
          questions: [],
        }),
    }),
    {
      name: "questionnaire-builder-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
